export default __webpack_public_path__ + "static/media/swp-img.abb05c72.svg";